import $ from 'jquery';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { ajax, getRealEventsapi } from 'requestES';
import { getActivityId, getParam, getCookie, setCookie } from 'utilsES';

const UUID_COOKIE_NAME = 'activity_uuid';
const ACTIVITY_ID = getActivityId();
const LISTEN_BASE_URL = `//${getRealEventsapi()}/static_activity/getClickInfo?enname=${ACTIVITY_ID}&activityId=${ACTIVITY_ID}&buttonName=`;

const getIEVersion = function() {
  return new Promise((resolve, reject) => {
    const userAgent = navigator.userAgent;
    const isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1; //是ie并且非edge
    if (isIE) {
      const reIE = new RegExp('MSIE (\\d+\\.\\d+);');
      reIE.test(userAgent);
      const IEVersion = parseFloat(RegExp['$1']);
      resolve(IEVersion < 9 ? 8 : 10); // 小于ie9返回8，否则返回10
    } else {
      resolve(10); // 非ie
    }
  });
};

const getFinger = function() {
  return new Promise((resolve, reject) => {
    getIEVersion().then(async (res) => {
      if (res === 10) {
        let uuid = localStorage.getItem(UUID_COOKIE_NAME);
        if (!uuid) {
          // 未保存指纹，重新生成
          let fp = await FingerprintJS.load();
          const result = await fp.get();
          let testIpUrl = '//gstore.endomainname.com/test_ip';
          ajax({
            url: testIpUrl
          }).then((res) => {
            let mixinData = '';
            if (parseInt(res.result, 10) === 1 && Object.prototype.toString.call(res.data) == '[object Object]') {
              mixinData = res.data;
            }
            // Mixin Props
            const mixinDataAction = function(key, value) {
              result.components[key] = {
                duration: 0,
                value: Array.isArray(value) ? value.join('-') : String(value)
              };
            };
            for (let prop in mixinData) {
              mixinDataAction(prop, mixinData[prop]);
            }
            // Rehash Components
            let newFingerID = FingerprintJS.hashComponents(result.components);
            localStorage.setItem(UUID_COOKIE_NAME, newFingerID);
            resolve(newFingerID);
          });
        } else {
          // 已保存指纹，直接获取
          resolve(uuid);
        }
      } else {
        reject('走小于ie9的逻辑');
      }
    });
  });
};

const getUUId = function() {
  return new Promise((resolve, reject) => {
    let uuid = getCookie(UUID_COOKIE_NAME);
    if (!uuid) {
      // 未保存UUID，请求获取
      ajax({
        url: `//${getRealEventsapi()}/static_activity/getUUID`
      }).then((data) => {
        setCookie(UUID_COOKIE_NAME, data.uuid, 730);
        resolve(data.uuid);
      });
    } else {
      // 已保存UUID，直接获取
      resolve(uuid);
    }
  });
};

// 访问统计
export const stat = function() {
  let url = `//${getRealEventsapi()}/static_activity/visit_log?name=${ACTIVITY_ID}&source_url=${encodeURIComponent(
    window.location.href
  )}&referer_url=${encodeURIComponent(document.referrer)}`;
  getFinger().then(
    (uuid) => {
      url = url + '&uuid=' + uuid;
      ajax({
        url: url
      }).catch((err) => {
        console.log(err);
      });
    },
    () => {
      getUUId().then((uuid) => {
        url = url + '&uuid=' + uuid;
        ajax({
          url: url
        }).catch((err) => {
          console.log(err);
        });
      });
    }
  );
};

// 打点统计()
/**
 * listen() 点击触发
 * ①：统计点击量
 * activity.listen({'btn1': '按钮1', 'btn2': '按钮2', 'btn3': '按钮3'}, 'click')
 * ②：统计点击人数
 * activity.listen({'btn1': '按钮1', 'btn2': '按钮2', 'btn3': '按钮3'}, 'user')
 */
export const listen = function(buttonInfo, type) {
  for (let key in buttonInfo) {
    $('body').on('click', '.' + key, function() {
      const listenKey = ACTIVITY_ID + buttonInfo[key];
      if (type === 'user' && localStorage.getItem(listenKey)) {
        return;
      }
      ajax({
        url: LISTEN_BASE_URL + buttonInfo[key]
      })
        .then((res) => {
          type === 'user' && localStorage.setItem(listenKey, 1);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }
};

/**
 * log(dec, type) 手动调用触发数据打点
 * 比如说：
 * $('.j-form-submit', function(){
 *      if (XXX) {
 *          log('用户在XXX条件下触发了提交按钮')
 *      }
 * })
 * @param des  后端数据统计那个表增加一列，表头标题就是这个参数
 * @param type user 表示一个用户只统计一次    click表示一个用户统计多次
 */
export const log = function(des, type) {
  const listenKey = ACTIVITY_ID + des;
  if (type === 'user' && localStorage.getItem(listenKey)) {
    return;
  }
  ajax({
    url: LISTEN_BASE_URL + des
  })
    .then((res) => {
      type === 'user' && localStorage.setItem(listenKey, 1);
    })
    .catch((err) => {
      console.log('log error', err);
    });
};
